<template>
  <div :class="bem()">
    <div :class="bem('icon')">
      <VisionIcon id="poplock" icon="poplock" size="stretch" gradient="custom"/>
    </div>
    <div :class="bem('text')">
      <p><span :class="bem('highlight')">Custom Built</span> For You</p>
      <p :class="bem('description')">This product is non-returnable.</p>
    </div>
    

    <ToolTip
      :class="bem('tooltip')"
      arrow-position="left"
      content="Custom SunGods are hand-built just for you, which means we can't offer returns on these products. To shop returnable products, choose from our Bestsellers or Limited Editions instead."
      icon-height="16px"
    />
  </div>
</template>

<script setup>
const bem = useBEM('CustomNoReturnsWarning')
</script>

<style lang="postcss" scoped>
.CustomNoReturnsWarning {
  @apply flex items-center gap-x-2
    w-full;
}

.CustomNoReturnsWarning__icon {
  @apply w-5 h-5 lg:w-6 lg:h-6 flex justify-center lgMax:mx-[2px];
}

.CustomNoReturnsWarning__tooltip {
  @apply ml-auto;
}

.CustomNoReturnsWarning__text {
  @apply text-sm font-medium;
}

.CustomNoReturnsWarning__description {
  @apply text-grey-600;
}

.CustomNoReturnsWarning__highlight {
  @apply t-gradient-custom;
}

.CustomNoReturnsWarning__tooltip {
  @apply ml-auto;
}
</style>